const csrfToken = () => {
  const meta = document.querySelector('meta[name=csrf-token]');
  return meta && meta.content;
};

export default csrfToken;
